import { render, staticRenderFns } from "./perfil-sociodemografico-grafica.vue?vue&type=template&id=cc82aa9e&scoped=true&"
import script from "./perfil-sociodemografico-grafica.vue?vue&type=script&lang=js&"
export * from "./perfil-sociodemografico-grafica.vue?vue&type=script&lang=js&"
import style0 from "./perfil-sociodemografico-grafica.vue?vue&type=style&index=0&id=cc82aa9e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc82aa9e",
  null
  
)

export default component.exports